<div class="input-container" contenteditable="true" #editableInput (input)="onInputChange($event)" (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)" autocomplete="off"  
autocorrect="off"
spellcheck="false">
  <!-- El texto con <user:id> se mostrará aquí -->
</div>
<ng-content></ng-content>
<div *ngIf="mentioning" class="user-suggestions" #userSuggestions [hidden]="!mentioning">
  <div *ngIf="filteredUsers.length === 0" class="no-users">
    <p>No hay usuarios disponibles</p>
  </div>
  <div *ngFor="let user of filteredUsers; let index = index" class="user-item" (click)="addMention(user)" [ngClass]="{'selected': index === selectedUserIndex}">
    <app-chat-user [user]="user"></app-chat-user>
    <div class="user-name">
      {{ user.name }}         
    </div>
    <div class="user-role">
      {{ user.role.name || "Puesto"}}
    </div>
  </div>
</div>